const { has, some, isEmpty } = require('lodash');
const { formTypeFlag } = require('../constants/common');
const templates = require('../constants/templates');

function TemplateModel() {
  const templateModelsMap = new Map();
  function addTemplateModel(key, properties) {
    const formFlags = Object.keys(formTypeFlag);
    if (!isEmpty(properties) && has(properties, 'ethosDestinationModel') && some(formFlags, form => has(properties, form))) {
      templateModelsMap.set(key, properties);
    }
  }
  function getTemplateProperty(key, property) {
    return (
      (templateModelsMap.has(key) &&
        templateModelsMap.get(key)[property]) ||
      false
    );
  }
  function getTemplateProperties(key) {
    return templateModelsMap.get(key) || {};
  }
  function getTemplatesListByProperty(property) {
    let allTemplateTypes = Array.from(templateModelsMap.keys());
    let templatesListByProperty = allTemplateTypes.filter((key) => {
      const templateModel = templateModelsMap.get(key);
      return templateModel && templateModel[property] && templateModel['isActive'];
    });
    return property ? templatesListByProperty : allTemplateTypes;
  }
  return {
    addTemplateModel,
    getTemplateProperty,
    getTemplateProperties,
    getTemplatesListByProperty
  }
}

const templateModelMap = TemplateModel();

Object.keys(templates).map((key) => {
  templateModelMap.addTemplateModel(key, templates[key]);
});

/**
 * Check if a template type is an inquiry form template.
 *
 * @param {string} type - The template type
 * @returns {boolean} - True if it is an inquiry form template
 */
const isInquiryFormTemplate = (type) => templateModelMap.getTemplateProperty(type, formTypeFlag.isInquiry);

/**
 * Check if a template type is an application form template.
 *
 * @param {string} type - The template type
 * @returns {boolean} - True if it is an application form template
 */
const isApplicationFormTemplate = (type) => templateModelMap.getTemplateProperty(type, formTypeFlag.isApplication);

/**
 * Check if a template type is a supplemental form template.
 *
 * @param {string} type - The template type
 * @returns {boolean} - True if it is a supplemental form template
 */
const isSupplementalFormTemplate = (type) => templateModelMap.getTemplateProperty(type, formTypeFlag.isSupplemental);

/**
 * Check if a template type is active.
 *
 * @param {string} type - The template type
 * @returns {boolean} - True if the template is active
 */
const isActiveTemplate = (type) => templateModelMap.getTemplateProperty(type, 'isActive');
/**
 * Gets the Ethos model for a given template type.
 *
 * @param {string} type - The template type.
 * @returns {string} The Ethos model for the template type, or empty string if not found.
 */
const getEthosModelByTemplate = (type) => templateModelMap.getTemplateProperty(type, 'ethosDestinationModel') || '';
/**
 * Get a list of all template types.
 *
 * @returns {Array<string>} The template types
 */
const allTemplatesTypes = () => templateModelMap.getTemplatesListByProperty();
/**
 * Get a list of active template types.
 *
 * @returns {Array<string>} The active template types
 */
const activeTemplateTypes = () => templateModelMap.getTemplatesListByProperty('isActive');
/**
 * Get a list of application template types.
 *
 * @returns {Array<string>} The application template types
 */
const applicationsTemplates = () => templateModelMap.getTemplatesListByProperty('isApplication');

module.exports = {
  TemplateModel,
  isInquiryFormTemplate,
  isApplicationFormTemplate,
  isSupplementalFormTemplate,
  isActiveTemplate,
  getEthosModelByTemplate,
  allTemplatesTypes,
  activeTemplateTypes,
  applicationsTemplates
}
